import { Link } from "react-router";

import { buttonClass, EmptyState, HelpLink } from "@/components/ui";

export function NotFoundPage() {
  return (
    <EmptyState
      title="Page not found"
      description="The page you're looking for doesn't exist or you don't have access to it."
      action={
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Link to="/" className={buttonClass("secondary")}>
            Back to dashboard
          </Link>
          <HelpLink helpKey="error:not_found" />
        </div>
      }
    />
  );
}
